import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Stats = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation({ threshold: 0.1 });

  const stats = [
    {
      value: '2.5k+',
      label: 'Minimum Units Recommended'
    },
    {
      value: '25-40%',
      label: 'Increased Profit Margin'
    }
  ];

  return (
    <section className="stats-wrapper" ref={sectionRef}>
      {/* Vertical Dividers - Full Grid System */}
      <div className="stats-divider stats-divider-2"></div>
      <div className="stats-divider stats-divider-3"></div>
      <div className="stats-divider stats-divider-4"></div>

      {/* Stats Container */}
      <div className={`stats-container ${sectionVisible ? 'animate-fade-up' : 'opacity-0'}`}>
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Corner Indicators */}
      <div className="stats-corner stats-corner-1"></div>
      <div className="stats-corner stats-corner-2"></div>
    </section>
  );
};

export default Stats;
